import React from "react";
import { Link } from "react-router-dom";
import { mediaUrl } from "@/lib/api";
import { Calendar } from "lucide-react";

export default function NewsCard({ article, variant = "default" }) {
  const cover = mediaUrl(article.cover) || "https://images.unsplash.com/photo-1542751371-adc38448a05e?w=800";

  if (variant === "row") {
    return (
      <Link
        to={`/news/${article.slug}`}
        data-testid={`news-row-${article.slug}`}
        className="group flex gap-4 items-start hover-rise card-surface rounded-xl p-3"
      >
        <div className="img-zoom w-28 h-20 shrink-0 rounded-lg overflow-hidden">
          <img src={cover} alt={article.title} className="w-full h-full object-cover" loading="lazy" />
        </div>
        <div className="min-w-0">
          <span className="eyebrow text-accent" style={{ color: "hsl(var(--accent))" }}>{article.category}</span>
          <h4 className="mt-1 text-sm font-semibold text-white line-clamp-2 group-hover:text-primary" style={{ color: "" }}>{article.title}</h4>
          <span className="mt-1 block text-xs text-white/40">{new Date(article.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric" })}</span>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${article.slug}`}
      data-testid={`news-card-${article.slug}`}
      className="group block card-surface rounded-xl overflow-hidden hover-rise"
    >
      <div className="img-zoom aspect-[16/10] overflow-hidden">
        <img src={cover} alt={article.title} className="w-full h-full object-cover" loading="lazy" />
      </div>
      <div className="p-4">
        <span className="eyebrow" style={{ color: "hsl(var(--accent))" }}>{article.category}</span>
        <h3 className="mt-2 text-base font-bold leading-snug text-white line-clamp-2 transition-colors group-hover:text-[hsl(var(--primary))]">
          {article.title}
        </h3>
        {article.excerpt && <p className="mt-2 text-sm text-white/50 line-clamp-2">{article.excerpt}</p>}
        <div className="mt-3 flex items-center gap-1.5 text-xs text-white/40">
          <Calendar size={12} /> {new Date(article.created_at).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
        </div>
      </div>
    </Link>
  );
}
